import React, { useState, useContext } from "react";
import { css } from "emotion";
import GenericButton from "../GenericButton";
import workspaces from "../../services/api/workspaces";
import { useParams, withRouter, useLocation } from "react-router-dom";
import { GlobalContext } from "../../context/GlobalState";
import { useStripe } from "@stripe/react-stripe-js";

const ConfirmOrderButton = ({ history }) => {
  const stripe = useStripe();
  const { currentWorkspace, setCurrentPlan } = useContext(GlobalContext);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const { planId } = useParams();
  const coupon = sessionStorage.getItem("coupon");

  const handleClick = async () => {
    setIsLoading(true);

    let subscriptionData = {
      workspace: currentWorkspace.id,
      planId,
    };

    if (coupon) {
      subscriptionData.coupon = coupon;
    }

    try {
      const { data } = await workspaces.updateSubscription(subscriptionData);

      if (data) {
        const paymentSource = data.customer.default_source;
        const clientSecret = data.clientSecret;

        const { paymentIntent, error } = await stripe.confirmCardPayment(
          clientSecret,
          {
            payment_method: paymentSource,
          }
        );
        if (error) {
          console.log(error);
        }
      }

      setCurrentPlan(planId);
      history.push("/home");
    } catch (error) {
      setError(
        "Looks like we encountered an error. Give our system a moment to calm down and try again."
      );
      setIsLoading(false);
      console.log("ERROR:", error);
    }
  };
  return (
    <div className={container}>
      <GenericButton
        text="Confirm Order"
        handleClick={handleClick}
        disabled={isLoading}
      />
    </div>
  );
};

export default withRouter(ConfirmOrderButton);

const container = css`
  margin: 30px auto 0;
  max-width: 240px;
  width: 100%;
`;
